import PdfProximosAgendamentos from "./PdfProximosAgendamentos";

function PdfProximosAgendamentosWrapper({
  showPreviousPage,
  proximosAgendamentosData,
}) {
  const showPreviousP = () => {
    showPreviousPage();
  };

  return (
    <div>
      <PdfProximosAgendamentos
        showPreviousPage={showPreviousP}
        proximosAgendamentosData={proximosAgendamentosData}
      />
    </div>
  );
}

export default PdfProximosAgendamentosWrapper;
